import { gql } from "@apollo/client";

const USER_LATEST_RESULTS = gql`
  query userLatestResults($userId: Int!) {
    userLatestResults(userId: $userId) {
      id

      tournament {
        title
        id
        startDate
        endDate
      }
      categoryId {
        category {
          name
        }
      }
      rank
      points
    }
  }
`;

export default USER_LATEST_RESULTS;
